import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Button, Table, Form, Card } from "react-bootstrap";
import Layout from "../../layout/Layout";
import Fancybox from "../../Component/FancyBox";
import Switch from "react-switch";
import { API } from "../../App";
import { toast } from "react-toastify";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import Pagination from "rc-pagination";
import Swal from "sweetalert2";
import Cookies from "js-cookie";

const KeyboardTheme = () => {
  const [keyboardThemeData, setKeyboardThemeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [dataLength, setDataLength] = useState(1);
  const [current, setCurrent] = useState(1);
  const [iconcoror, Seticoncoror] = useState("name_up");
  const [perPage, setPerPage] = useState(10);
  const [size, setSize] = useState(perPage);
  const [search, setSearch] = useState({
    name: "",
    is_premium: "",
    status: "",
  });
  var arr = [];

  const handleGetKeyboardThemeData = async (sortData) => {
    setLoading(true);
    const token = Cookies.get("jwt");
    const res = await API.post(
      "/keyboardThemesData",
      {},
      { headers: { authorization: `Bearer ${token}` } }
    );
    if (res.data.response_code === 0) {
      navigate("/");
      setLoading(false);
    } else {
      setKeyboardThemeData(res.data.data);
      setLoading(false);
    }
  };

  const change = async (id, e, name, ind) => {
    var Status;
    Status = e === true ? true : false;
    toast.success("Update Data successfully", {
      position: "bottom-right",
      autoClose: 500,
    });
    if (name === "status") {
      const data1 = keyboardThemeData;
      data1[ind].status = Status;
      setKeyboardThemeData(data1);
    } else {
      const data1 = keyboardThemeData;
      data1[ind].is_premium = Status;
      setKeyboardThemeData(data1);
    }
    const Form = new FormData();
    Form.append("id", id);
    Form.append("name", name);
    Form.append("Status", Status);

    await API.post("/keyboardUpdateStatusLive", Form);
    handleGetKeyboardThemeData();
  };

  const handleSearchData = async (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });

    const res = await API.post(`/keyboardSearchDataLive`, {
      name: e.target.name === "name" ? e.target.value : search.name,
      is_premium:
        e.target.name === "is_premium" ? e.target.value : search.is_premium,
      status: e.target.name === "status" ? e.target.value : search.status,
    });
    setKeyboardThemeData(res.data.data);
    if (res.data.data.length === 0) {
      setDataLength(0);
    } else {
      setDataLength(1);
    }
  };

  const deleteUser = async (_id) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger me-3",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const dele = await API.post(`/keyboardThemesDel/${_id}`);
          handleGetKeyboardThemeData();
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
        }
      });
  };

  const getData = (current, pageSize) => {
    return keyboardThemeData.slice(
      (current - 1) * pageSize,
      current * pageSize
    );
  };

  const PerPageChange = (value) => {
    setSize(value);

    const newPerPage = Math.ceil(keyboardThemeData.length / value);
    if (current > newPerPage) {
      setCurrent(newPerPage);
    }
  };

  const PaginationChange = (page, pageSize) => {
    setCurrent(page);
    setSize(pageSize);
  };

  const PrevNextArrow = (current, type, originalElement) => {
    if (type === "prev") {
      return <button className="paggination-btn">Previous</button>;
    }
    if (type === "next") {
      return <button className="paggination-btn">Next</button>;
    }
    return originalElement;
  };

  const sorting = (col, order, e) => {
    Seticoncoror(e.target.id);
    if (order === "ASC") {
      if (col === "status" || col === "is_premium") {
        const sorted = [...keyboardThemeData].sort((a, b) =>
          a[col] === b[col] ? 1 : -1
        );
        if (iconcoror !== e.target.id) {
          setKeyboardThemeData(sorted);
        }
      } else {
        const sorted = [...keyboardThemeData].sort((a, b) =>
          a[col] > b[col] ? 1 : -1
        );
        if (iconcoror !== e.target.id) {
          setKeyboardThemeData(sorted);
        }
      }
    }
    if (order === "DSC") {
      if (col === "status" || col === "is_premium") {
        const sorted = [...keyboardThemeData].sort((a, b) =>
          a[col] === b[col] ? 1 : -1
        );
        if (iconcoror !== e.target.id) {
          setKeyboardThemeData(sorted);
        }
      } else {
        const sorted = [...keyboardThemeData].sort((a, b) =>
          a[col] < b[col] ? 1 : -1
        );
        if (iconcoror !== e.target.id) {
          setKeyboardThemeData(sorted);
        }
      }
    }
  };

  const handleDragEnd = async (e) => {
    if (!e.destination) return;
    let tempData = Array.from(keyboardThemeData);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setKeyboardThemeData(tempData);
    tempData.map((val, index) => {
      arr.push({ id: val._id, rank: index + 1 });
    });

    const result = await API.post("/keyboardUpdateIndexLiveTheme", arr);
    console.log(result);
    if (result.data.response_code === 1) {
      toast.success(result.data.response_message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
        closeOnClick: true,
      });
      handleGetKeyboardThemeData();
    } else {
      toast.error(result.data.response_message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
        closeOnClick: true,
      });
    }
  };

  useEffect(() => {
    handleGetKeyboardThemeData();
  }, []);

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3 className="my-1">Keyboard Theme</h3>
        <Row className="align-items-center">
          <Col md="auto" xs={12}>
            <Form.Control
              type="text"
              name="name"
              id=""
              placeholder="Search Name"
              className="my-1"
              onChange={handleSearchData}
            />
          </Col>
          <Col md="auto" xs={12}>
            <Form.Select
              className="my-1"
              name="is_premium"
              onChange={handleSearchData}
            >
              <option value="">Select Premium</option>
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </Form.Select>
          </Col>
          <Col md="auto" xs={12}>
            <Form.Select
              className="my-1"
              name="status"
              onChange={handleSearchData}
            >
              <option value="">Select Status</option>
              <option value={true}>On</option>
              <option value={false}>Off</option>
            </Form.Select>
          </Col>
          <Col md="auto" xs={6}>
            <Form.Select
              className="my-1"
              onChange={(e) => {
                setSize(Number(e.target.value));
                setCurrent(1);
              }}
            >
              {[10, 25, 50, 100].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  {pageSize}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md="auto" xs={12}>
            <Link to="/keyboard/theme/add">
              <Button variant="primary" className="my-1" value="create">
                Add New
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
      <div className="page-content">
        <Row>
          <Col xs={12}>
            <Card>
              <Card.Body>
                <DragDropContext onDragEnd={handleDragEnd}>
                  {loading && <div className="loader table-loader" />}
                  <Table bordered responsive id="myTable">
                    <thead>
                      <tr>
                        <th width="5%" className="text-center">
                          No
                        </th>
                        <th width="35%">
                          <div className="table-sort-filter">
                            Name
                            {keyboardThemeData.length > 1 ? (
                              <span className="table-sort">
                                <div
                                  className={`sort-down ${
                                    iconcoror === "name_up" ? "active" : ""
                                  }`}
                                  id="name_up"
                                  onClick={(e) => {
                                    sorting("name", "ASC", e);
                                  }}
                                ></div>
                                <div
                                  className={`sort-up ${
                                    iconcoror === "name_down" ? "active" : ""
                                  }`}
                                  id="name_down"
                                  onClick={(e) => {
                                    sorting("name", "DSC", e);
                                  }}
                                ></div>
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </th>
                        <th width="15%" className="text-center">
                          Thumb Image
                        </th>
                        <th width="15%">
                          <div className="table-sort-filter justify-content-center">
                            Is Premium
                            {keyboardThemeData.length > 1 ? (
                              <span className="table-sort">
                                <div
                                  className={`sort-down ${
                                    iconcoror === "is_premium_up"
                                      ? "active"
                                      : ""
                                  }`}
                                  id="is_premium_up"
                                  onClick={(e) => {
                                    sorting("is_premium", "ASC", e);
                                  }}
                                ></div>
                                <div
                                  className={`sort-up ${
                                    iconcoror === "is_premium_down"
                                      ? "active"
                                      : ""
                                  }`}
                                  id="is_premium_down"
                                  onClick={(e) => {
                                    sorting("is_premium", "DSC", e);
                                  }}
                                ></div>
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </th>
                        <th width="15%">
                          <div className="table-sort-filter justify-content-center">
                            Status
                            {keyboardThemeData.length > 1 ? (
                              <span className="table-sort">
                                <div
                                  className={`sort-down ${
                                    iconcoror === "status_up" ? "active" : ""
                                  }`}
                                  id="status_up"
                                  onClick={(e) => {
                                    sorting("status", "ASC", e);
                                  }}
                                ></div>
                                <div
                                  className={`sort-up ${
                                    iconcoror === "status_down" ? "active" : ""
                                  }`}
                                  id="status_down"
                                  onClick={(e) => {
                                    sorting("status", "DSC", e);
                                  }}
                                ></div>
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </th>
                        <th width="15%" className="text-center">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <Droppable droppableId="droppable-1">
                      {(provider) => (
                        <tbody
                          ref={provider.innerRef}
                          {...provider.droppableProps}
                        >
                          {getData(current, size).map((val, id) => (
                            <Draggable
                              key={val._id}
                              draggableId={val._id}
                              index={id}
                            >
                              {(provider) => (
                                <tr
                                  key={id}
                                  {...provider.draggableProps}
                                  ref={provider.innerRef}
                                  {...provider.dragHandleProps}
                                >
                                  <td className="text-center">{id + 1}</td>
                                  <td>{val.name}</td>
                                  <td className="text-center">
                                    <Fancybox>
                                      {val.image === "" ||
                                      val.image === null ? (
                                        ""
                                      ) : (
                                        <>
                                          <a
                                            data-fancybox="thumb-image"
                                            href={val.thumb_image}
                                          >
                                            <img
                                              src={val.thumb_image}
                                              className="hv-40 bg-light"
                                              alt="Thumb Image"
                                            />
                                          </a>
                                        </>
                                      )}
                                    </Fancybox>
                                  </td>
                                  <td className="text-center">
                                    <Switch
                                      onChange={(e) => {
                                        change(val._id, e, "is_premium", id);
                                      }}
                                      checked={
                                        val.is_premium === true ? true : false
                                      }
                                      offColor="#C8C8C8"
                                      onColor="#0093ed"
                                      height={30}
                                      width={70}
                                      className="react-switch"
                                      uncheckedIcon={
                                        <div className="react-switch-off">
                                          YES
                                        </div>
                                      }
                                      checkedIcon={
                                        <div className="react-switch-on">
                                          NO
                                        </div>
                                      }
                                    />
                                  </td>
                                  <td className="text-center">
                                    <Switch
                                      onChange={(e) => {
                                        change(val._id, e, "status", id);
                                      }}
                                      checked={
                                        val.status === true ? true : false
                                      }
                                      offColor="#C8C8C8"
                                      onColor="#0093ed"
                                      height={30}
                                      width={70}
                                      className="react-switch"
                                      uncheckedIcon={
                                        <div className="react-switch-off">
                                          OFF
                                        </div>
                                      }
                                      checkedIcon={
                                        <div className="react-switch-on">
                                          ON
                                        </div>
                                      }
                                    />
                                  </td>
                                  <td className="text-center">
                                    <Link
                                      to={`/keyboard/theme/view/${val._id}`}
                                    >
                                      <Button
                                        variant="outline-warning"
                                        size="sm"
                                        className="me-2 btn-icon"
                                      >
                                        <i className="bx bx-show"></i>
                                      </Button>
                                    </Link>

                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      className="btn-icon"
                                    >
                                      <i
                                        className="bx bx-trash-alt"
                                        onClick={() => deleteUser(val._id)}
                                      ></i>
                                    </Button>
                                  </td>
                                </tr>
                              )}
                            </Draggable>
                          ))}
                        </tbody>
                      )}
                    </Droppable>
                    {keyboardThemeData.length === 0 ? (
                      <tr>
                        <td colSpan="100%" className="p-0">
                          <div className="no-found">
                            <img src="../../not-found/live-theme.svg" />
                            <p>No Found Keyboard Theme </p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                  </Table>
                </DragDropContext>

                {keyboardThemeData.length > size ? (
                  <div className="pagination-custom">
                    <Pagination
                      className="pagination-keyboardThemeData"
                      onChange={PaginationChange}
                      total={keyboardThemeData.length}
                      current={current}
                      pageSize={size}
                      showSizeChanger={false}
                      itemRender={PrevNextArrow}
                      onShowSizeChange={PerPageChange}
                      showTitle={false}
                    />
                  </div>
                ) : (
                  ""
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </Layout>
  );
};

export default KeyboardTheme;
